<template>
  <div v-if="user">
    <h1>SITES</h1>
    <div v-if="sites">
      <div class="array-wrapper" v-for="(site, index) in sites" :key="index">
        <div class="array-item" v-if="site.name"><b>Name:</b><br>{{ site.name }}</div>
        <div class="array-item" v-if="site.date"><b>Date:</b><br>{{ site.date }}</div>
        <div class="array-item" v-if="site.api_value"><b>API value:</b><br>{{ site.api_value }}</div>
        <div class="array-item" v-if="site.url"><b>URL:</b><br>{{ site.url }}</div>
        <div class="array-item" v-if="!site.url"><b>URL:</b><br>Any</div>
        <div class="array-item" v-if="site.title"><b>Title:</b><br>{{ site.title }}</div>
        <div class="array-item" v-if="site.user_key"><b>Key:</b><br>{{ site.user_key }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['user']),
    ...mapGetters(['sites']),
  }
}
</script>